// ============================================================================
// InactiveAccountScreen — what a deactivated account sees (migration 218)
// ============================================================================
// App renders this instead of any route once the profile has POSITIVELY loaded
// with role 'inactive' (src/lib/access.ts isInactiveAccount). The server
// refuses such an account every table, Storage object and new login, so there
// is nothing to show: one plain card inside the normal Header, which itself
// drops its program chips, section strip, menus and reads for this account.
//
// Deliberately data-free. This module imports no API, starts no request and
// mounts no route resource; the only action is Sign Out.
// ============================================================================
import {useAuth} from '../contexts/AuthContext.jsx';
import Header from './Header.tsx';
import InactiveAccountCard from './InactiveAccountCard.tsx';
import {RecordPageBody, RecordPageFrame} from './RecordPageShell.jsx';

export default function InactiveAccountScreen() {
  const {signOut} = useAuth();
  return (
    <RecordPageFrame Header={Header} data-inactive-account="1">
      <RecordPageBody maxWidth={560} style={{paddingTop: 24}}>
        <InactiveAccountCard onSignOut={() => void signOut()} />
      </RecordPageBody>
    </RecordPageFrame>
  );
}
